<template>
  <transition name="fade-slide">
    <div v-if="visible" :class="classes" data-test-id="dropdown" v-on="$listeners">
      <slot />
    </div>
  </transition>
</template>

<script>
import classes from '~~/common/vue/mixins/classes';

export const sides = ['left', 'center', 'right'];

export default {
  name: 'EDropdown',
  mixins: [classes],
  props: {
    /**
     * The side for the dropdown `left, right`
     */
    side: {
      type: String,
      default: 'left',
      validator: (value) => sides.includes(value),
      cssClass: true,
    },
    /**
     * The visibility for the dropdown
     */
    visible: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown {
  @include elevation(2);

  --slide-animation: e-slide-top;

  position: absolute;
  top: 100%;
  min-width: 184px;
  background-color: var(--color-background-elevation-1);
  border-radius: $border-radius-l;
  overflow: hidden;
  z-index: $z-index-1l;
}

.dropdown--side-left {
  left: 0;
}

.dropdown--side-center {
  --slide-animation: e-slide-top-center;

  left: 50%;
  transform: translateX(-50%);
}

.dropdown--side-right {
  right: $space-s;
}

.fade-slide-enter-active {
  animation: e-fade-in $timing-1s both, var(--slide-animation) $timing-1s both;
}

.fade-slide-leave-active {
  animation: e-fade-in $timing-1s both reverse, var(--slide-animation) $timing-1s both reverse;
}
</style>
